export const AUTOMATED_COMMUNICATION_SYSTEM = {
  SuitebookCalls: 1,
  Alex: 2,
} as const

export function hasAutomatedCommunicationSystemContract(
  value: unknown
): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0
}

export function usesAlexAutomatedCommunicationSystem(value: number) {
  return (
    (value & AUTOMATED_COMMUNICATION_SYSTEM.Alex) ===
    AUTOMATED_COMMUNICATION_SYSTEM.Alex
  )
}

export type AutomatedCommunicationSystemResolution =
  | {
      ok: true
      value: number
    }
  | { ok: false; reason: 'reception_device_contract_missing' }

export function resolveAutomatedCommunicationSystem({
  apiValue,
}: {
  apiValue: unknown
}): AutomatedCommunicationSystemResolution {
  if (!hasAutomatedCommunicationSystemContract(apiValue)) {
    return { ok: false, reason: 'reception_device_contract_missing' }
  }

  return {
    ok: true,
    value: apiValue,
  }
}
